import { useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../Core/types';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { WorksheetGridFieldSection, WorksheetRecordGrid } from '../../../Core';
import deepEquals from '../../../../../Lib/Object/deepEquals';
import { hasNonEmptyValue } from 'Lib/Any';
import { airDriedMassGridFieldSet } from '../gridFieldSets';
import { DateTimeStyle } from 'Components/Layout/Grid/types';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';

interface AirDryingDryMassesSectionProps extends IWorksheetComponent {
  visible?: boolean;
}
let AirDryingDryMassesSectionBase = ({
  visible,
  createWorksheetSelector,
}: AirDryingDryMassesSectionProps): JSX.Element => {
  const dryMassReadings = useSelector(createWorksheetSelector!('AirDrying.DryMassReadings'), deepEquals) || [];

  const confirmDryMassReadingRemove = ({ name }: any) => hasNonEmptyValue(dryMassReadings[name]?.TareAndDryMass);
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));
  return (
    <WorksheetGridFieldSection name="AirDrying.DryMassReadings" visible={visible}>
      <WorksheetRecordGrid
        name="AirDrying.DryMassReadings"
        orientation={'vertical'}
        recordProps={{
          preventRemove: dryMassReadings.length <= 2,
          removeConfirm: {
            confirm: confirmDryMassReadingRemove,
            confirmTitle: 'Dry Mass Reading Deletion',
            confirmText: 'Are you sure you want to remove the selected dry mass reading?',
            confirmButtonText: 'Delete Reading',
          },
        }}
        fieldSet={airDriedMassGridFieldSet(dryMassEntryOption, DateTimeStyle.Combined)}
      />
    </WorksheetGridFieldSection>
  );
};

const AirDryingDryMassesSection = withInjectedProps(AirDryingDryMassesSectionBase);
export { AirDryingDryMassesSection };
export default AirDryingDryMassesSection;
